import React, { Component } from 'react';
import styled from 'styled-components'
import { Card, Divider } from 'antd'

// Import mock util (using relative path within src)
// import { apiUtil as Util } from '../../mock/mockServices';

// const DWForm = Form.create({ name: 'dw-config-form' })(class extends Component {

//     state = {
//         host:'',
//         port: '',
//         // database: '',
//         username: '',
//         password: ''
//     }

//     componentDidMount() {
//         Util.ajax.get('/config/getConfig', {
//             type: 'hive'
//         }).then(res => {
//             const {data} = res
//             if(!data){
//                 return false
//             }
//             const host = data.find(e => e.name === 'host')
//             const port = data.find(e => e.name === 'port')
//             // const database = data.find(e => e.name === 'database')
//             const username = data.find(e => e.name === 'username')
//             const password = data.find(e => e.name === 'password')
//             this.setState({
//                 host: host ? host.value : '',
//                 port: port ? port.value : '',
//                 // database: database ? database.value : '',
//                 username: username ? username.value : '',
//                 password: password ? password.value : '',
//             })
//         })
//     }

//     handleSubmit = e => {
//         e.preventDefault();
//         this.props.form.validateFields((err, values) => {
//           if (!err) {
//             console.log('Received values of form: ', values);
//             let pms = { ...values }
//             let configs = [
//                 {
//                     name: 'host',
//                     value: pms.host
//                 },
//                 {
//                     name: 'port',
//                     value: pms.port
//                 },
//                 {
//                     name: 'username',
//                     value: pms.username
//                 },
//                 {
//                     name: 'password',
//                     value: pms.password
//                 }
//             ]
//             Util.ajax.post('/config/submitConfig', {
//                 type: pms.type,
//                 configs
//             }).then(res => {
//                 Util.message.success('Saved successfully')
//             })
//           }
//         });
//     }

//     handleTest = e => {
//         this.props.form.validateFields((err, values) => {
//             if (!err) {
//               Util.ajax.get('/config/testHiveDataSource', {
//                     host: values.host,
//                     port: values.port,
//                     // database: values.database,
//                 }).then(res => {
//                     Util.message.success('Test connection successful, please save')
//                 })
//             }
//         })
//     }

//     render() {
//         const { getFieldDecorator } = this.props.form;
//         return (
//             <Form layout="horizontal" {...formItemLayout} style={{width: '660px'}} onSubmit={this.handleOk}>
//                 <Form.Item label="Database Type">
//                 {getFieldDecorator('type', {
//                     initialValue:'hive'
//                 })(<Select disabled>
//                         <Option value="hive">HIVE</Option>
//                     </Select>)}
//                 </Form.Item>
//                 <Form.Item label="Database Host">
//                 {getFieldDecorator('host', {
//                     initialValue:this.state.host,
//                     rules: [
//                         { required: true, message: 'Please enter the database host', whitespace: true },
//                     ]
//                 })(<Input />)}
//                 </Form.Item>
//                 <Form.Item label="Port">
//                 {getFieldDecorator('port', {
//                     initialValue:this.state.port,
//                     rules: [
//                         { required: true, message: 'Please enter the port', whitespace: true },
//                     ]
//                 })(<Input />)}
//                 </Form.Item>
//                 {/* <Form.Item label="数据库名称">
//                 {getFieldDecorator('database', {
//                     initialValue:this.state.database,
//                     rules: [
//                         { required: true, message: '请填写名称', whitespace: true },
//                     ]
//                 })(<Input />)}
//                 </Form.Item> */}
//                 <Form.Item label="Username">
//                 {getFieldDecorator('username', {
//                     initialValue:this.state.username,
//                     rules: [
//                         // { required: true, message: 'Please enter the username', whitespace: true },
//                     ]
//                 })(<Input />)}
//                 </Form.Item>
//                 <Form.Item label="Password">
//                 {getFieldDecorator('password', {
//                     initialValue:this.state.password,
//                     rules: [
//                         // { required: true, message: 'Please enter the password', whitespace: true },
//                     ]
//                 })(<Input type="password" />)}
//                 </Form.Item>
//                 <Form.Item label="" wrapperCol={{push: 4}}>
//                     <Button className="mr20"  onClick={this.handleTest}>Test Connection</Button>
//                     <Button type="primary"  onClick={this.handleSubmit}>Save</Button>
//                 </Form.Item>
//             </Form>
//         )
//     }
// })

export default class DWConfig extends Component {

    render() {
        return (
            <Root>
                <div className="page-content">
                    <Card title={
                        <div style={{fontSize:'22px', fontWeight:'bold'}}>Data Source Configuration</div>
                    } bordered={false} style={{ width: '100%' }}>
                        {/* <div className="title"></div>
                        <Divider></Divider> */}
                        <div className="sub-title">Training</div>
                        <div>Data comes from csv or txt files, no configuration required</div>
                        <Divider></Divider>
                        <div className="sub-title">Local Prediction</div>
                        <div>Data comes from csv or txt files, no configuration required</div>
                    </Card>
                </div>
            </Root>
            
        )
    }
}

const Root = styled.div`
    .title{
        font-size: 22px;
        font-weight: bold;
    }
    .sub-title{
        font-size:18px;
        font-weight: bold;
        padding: 5px 0 15px;
    }
`